<template>
    <div v-if="room.tariff && ownProduct" class="tariff-label d-flex align-center">
        <v-icon start size="small" class="text-info">mdi-tag-text</v-icon>
        {{ room.tariff }}
    </div>
</template>

<script lang="ts">
    import {Component, Prop, Vue} from 'vue-facing-decorator'

    @Component
    export class TariffLabel extends Vue {
        @Prop({required: true}) room
        @Prop({required: true}) hotel

        get ownProduct() {
            return hotelsRuntimeStore.ownProduct(this.hotel)
        }
    }

    export default TariffLabel
</script>
